import React from "react";
import styled from "styled-components";
import overlayImage from "images/overlay.png";
import rapidoGreenTintedPhoto from "images/rapido-green-overlay.jpg";
import { media } from "utils/style-utils";

const OverlayContainer = styled.div`
  background-image: url('${overlayImage}');
  background-repeat: tile;
`;

const StyledHero = styled.div`
  background-image: url('${props => props.background}');
  background-attachment: fixed;
  background-size: cover;
  background-repeat: none;

  ${media.mobile`
    background-attachment: scroll;
  `}

`;

const QuoteContainer = () => (
  <StyledHero className="hero is-medium is-dark" background={rapidoGreenTintedPhoto}>
    <OverlayContainer className="hero-body">
      <div className="container has-text-centered">
        <div className="columns is-centered">
          <div className="column is-6">
            <h1 className="title is-2 has-text-light">Who Are We?</h1>
            {/* <p>
              Accratronics is a family-owned and operated, end-to-end machine
              shop, specializing in the creation of hermetically sealed
              connectors and parts for the aerospace, defense, and space travel
              industries.
            </p> */}
            <p>
              Accratronics is an end-to-end machine shop specializing in the creation 
              of hermetically sealed connectors and parts for the aerospace, defense, 
              and space travel industries.
            </p>
          </div>
        </div>
      </div>
    </OverlayContainer>
  </StyledHero>
);

export default QuoteContainer;



// WEBPACK FOOTER //
// ./src/pages/Home/components/WhoWeAre.js